"use client";

import { cn, getFilePath } from "@/lib/utils/utils";
import Image from "next/image";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { XIcon } from "lucide-react";
import useLocalizer from "@/hooks/useLocalizer";

interface Props {
  className?: string;
  images: { path: string; alt?: string | null }[];
}

const GalleryContainer: React.FC<Props> = ({ className, images }) => {
  const { isRtl } = useLocalizer();
  return (
    <div className={cn("grid lg:grid-cols-2 gap-4 mt-5", className)}>
      {images?.map((image, index) => (
        <Dialog key={index}>
          <DialogTrigger asChild>
            <article
              className="flex flex-col gap-4 w-full h-48 relative overflow-hidden cursor-pointer hover:opacity-90 transition-opacity"
              aria-label={
                image?.alt ||
                (isRtl ? "عرض الصورة بالحجم الكامل" : "View full size image")
              }
              role="button"
            >
              <div className="w-full h-full relative">
                <Image
                  src={getFilePath(image.path) ?? ""}
                  alt={image?.alt ?? ""}
                  fill
                  priority
                  placeholder="empty"
                  className="object-cover bg-center"
                />
              </div>
            </article>
          </DialogTrigger>
          <DialogContent className=" max-w-screen w-full max-h-screen h-full p-0 bg-black/95 border-none rounded-none flex items-center justify-center overflow-hidden">
            <DialogHeader className="sr-only">
              <DialogTitle>View Image</DialogTitle>
            </DialogHeader>
            <div className="relative w-full h-full">
              <DialogClose className="absolute top-[50%] left-[50%]   duration-300 hover:scale-110 -translate-x-1/2 -translate-y-1/2 z-50 p-3 bg-black h-20 w-20 flex items-center justify-center rounded-full transition-all  text-white ">
                <XIcon className="size-7" />
                <span className="sr-only">Close</span>
              </DialogClose>
              <Image
                src={getFilePath(image.path) ?? ""}
                alt={image?.alt ?? ""}
                fill
                className="object-contain"
                priority
              />
            </div>
          </DialogContent>
        </Dialog>
      ))}
    </div>
  );
};

export default GalleryContainer;
